export default __webpack_public_path__ + "static/media/welcome-spinner-static.5dbf132b.svg";